import { buildStyleFromLiteral } from '../tools/services/styles-literal'
import { getColorArray } from '../tools/services/colors'

export default function ({ color = [255, 255, 0], opacity = 0.5, width = 10 } = {}) {
  return buildStyleFromLiteral({
    stroke: { width, color: getColorArray(color, opacity) },
  })
}
